import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const FormSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link from="/$organizationId/settings/forms/$formId" to="/$organizationId/settings/forms">
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Forms
					</Button>
				</Link>
			}
		/>
	)
})
FormSettingsDetailViewTopBar.displayName = "FormSettingsDetailViewTopBar"
